import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7670ff75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-card" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "title-four title-overflow" }
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "is-flex is-justify-content-center mt-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-search-plus" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon fa-lg fas fa-search-minus" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

import { onMounted, ref } from 'vue'
import { v4 as uuidv4 } from "uuid"
import {
  InteractiveProps,
  useInteractiveEventListeners
} from '@/components/common/useInteractiveEventListeners'


export default /*#__PURE__*/_defineComponent({
  __name: 'TwoDModal',
  props: {
  filepath: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  }
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const props = __props

const imageViewer = ref<HTMLImageElement|null>(null)
const uuidPrefix = uuidv4()
const previewContainerId = `preview-container-${uuidPrefix}`

const close = () => emit('close')

// common variables
const imageScale = ref(1.00)
const isPanning = ref(false)
const panPosition = ref({ x: 0, y: 0 })

const { zoomIn, zoomOut } = useInteractiveEventListeners(
  new InteractiveProps({
    imageScale: imageScale,
    isPanning: isPanning,
    panPosition: panPosition,
    previewContainerId: previewContainerId
}))

onMounted(async () => {
  // Prevent fetch if filepath is empty
  if (!!props.filepath) {
    const res = await fetch(props.filepath)
    const blob = await res.blob()

    if (!!imageViewer.value) {
      imageViewer.value.src = URL.createObjectURL(blob)
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["is-active modal", { 'grabbing': isPanning.value }])
  }, [
    _createElementVNode("div", {
      class: "modal-background",
      onClick: close
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "is-pulled-right delete",
            "aria-label": "close",
            onClick: close
          }),
          _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["preview", { 'grabbing': isPanning.value }]),
          id: previewContainerId
        }, [
          _createElementVNode("img", {
            ref_key: "imageViewer",
            ref: imageViewer,
            alt: __props.title,
            style: _normalizeStyle({ 'scale': imageScale.value, transform: `translate(${panPosition.value.x}px, ${panPosition.value.y}px)` })
          }, null, 12, _hoisted_5)
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "button is-white",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(zoomIn) && _unref(zoomIn)(...args)))
          }, _hoisted_8),
          _createElementVNode("button", {
            class: "button is-white",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(zoomOut) && _unref(zoomOut)(...args)))
          }, _hoisted_10)
        ])
      ])
    ])
  ], 2))
}
}

})